export const CATALOG_EDITOR_OPTIONS = [
  "id",
  "name",
  "createdAt",
  "createdBy",
  "subcatalogCount",
];
